import { create } from 'zustand';
import type { Card } from '../game/data/cards/types';

// One global slot for "which card is the player inspecting".
//
// A store rather than props because the ask is "on any place" — shop, board,
// hand, draft, discover, results. Threading an onInspect callback through
// every one of those call sites would mean editing every screen; the openers
// (CardTile's secondary click, the ActionBar's Info verb) just push a card
// in here and a single host renders it.
//
// HISTORY — this used to carry an `ownerId`, and CardDetail was rendered
// *inside* the CardTile whose id matched. That made any non-tile opener
// impossible: the ActionBar's Info button called open(card, 'actionbar'), no
// tile ever owned that id, and the lightbox silently never mounted. The
// lightbox portals to document.body regardless of where it is rendered from,
// so ownership bought nothing and cost a whole broken entry point. It is now
// mounted once in RouteLayout — see CardDetailHost.
//
// Deliberately NOT persisted: an open lightbox is transient view state and
// should never survive a reload into a match that has moved on.

interface CardDetailState {
  card: Card | null;
  open: (card: Card) => void;
  close: () => void;
}

export const useCardDetailStore = create<CardDetailState>((set) => ({
  card: null,
  open: (card) => set({ card }),
  close: () => set({ card: null }),
}));
